const handleWheel = (event) => { //Prevents the scroll-wheel from changing the value
    event.target.blur();
};
const handleRememberScroll = (e, scroll_storage_key, scrollTimerRef = undefined, minimumScroll = undefined) => {
    let scrollPosition = e.target.scrollTop;
    if (minimumScroll && scrollPosition < minimumScroll) { //If it's less than minimumScroll pixels scrolled, it just makes sets it to the top
        scrollPosition = "0";
    }
    if (scrollTimerRef) {
        if (scrollTimerRef.current) {
            clearTimeout(scrollTimerRef.current);
        }
        scrollTimerRef.current = setTimeout(() => {
            sessionStorage.setItem(scroll_storage_key, scrollPosition);
        }, 250);
    } else {
        sessionStorage.setItem(scroll_storage_key, scrollPosition);
    }
};
const restoreScrollPosition = (nodeElement, scroll_storage_key, scrollOffset = 0) => {
  if (nodeElement) {
    const savedPosition = sessionStorage.getItem(scroll_storage_key);
    if (savedPosition && (!scrollOffset || savedPosition > scrollOffset)) {
      nodeElement.scrollTop = parseInt(savedPosition) - scrollOffset;
    }
  }
}
const handleKeyDown = (event) => { //Prevents the up/down arrow keys from changing the value
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
    }
};
const handleCtrlSKeyDown = (event, saveFunction, saveEnable) => { //Prevents the webbrowser's default save page dialogue and let's us run a designated function instead, saveEnable is if we don't want to actually want to run the function (at least not yet) and we only want to prevent the browser webpage save dialog or until we want to allow the user to save, for example if they ctrl+s but they made no changes then we don't want to run the function passed to it
    if ((event.ctrlKey || event.metaKey) && event.key === "s") {    //CTRL + S
        event.preventDefault();
        if (saveEnable && saveFunction) {
            saveFunction();
        }
    }
}
export { handleWheel, handleRememberScroll, restoreScrollPosition, handleKeyDown, handleCtrlSKeyDown };